import LoginForm from "../../components/auth/forms/OrganisationLoginForm";

const OrganisationLoginPage = () => {
    return (
        <div>
            <LoginForm />
        </div>
    );
};

export default OrganisationLoginPage;
